import { useRef } from "react";

export const useFocus = (): any => {
    const htmlElRef = useRef(null);
    const setFocus = (): any => {
        htmlElRef.current && htmlElRef.current.focus();
    };

    return [htmlElRef, setFocus];
};

export default useFocus;
